module.exports = "/_next/static/images/dc956bb15db59fea0505db5ff88b566a-roxinho-single-lg@2x.jpg";